import powerbi from '@/views/powerbi'

var routes = [
    {
        path: '/relatorios/bi/:id',
        name: 'relatorios.bi',
        component: powerbi,
        meta: {
            protect: true,
        }
    }
]

export { routes }